module.exports = __webpack_public_path__ + "static/img/hzhb03.2add729.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/hzhb03.jpg
// module id = Mj8F
// module chunks = 11